import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ModalConfirmComponent } from '../../../../../shared/modal-confirm/modal-confirm.component';
import { PixKey, SituacaoReividicacao } from '../../../models/key.model';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixKeysService } from '../../keys.service';
import { PixMenu } from '../../../models/pix-menu.enum';
import { Util } from '../../../../../utils/util';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../../shared/EventTypes';
import { PixHelpComponent } from '../../../help/help.component';
import * as moment from 'moment';
import { PixKeysClaimService } from '../../keys-claim.service';
import { PixKeyClaim } from '../../../models/key-claim.model';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';

@Component({
	selector: 'app-pix-keys-list',
	templateUrl: './keys.component.html',
	styleUrls: ['./keys.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysListComponent implements OnInit {

	public dataSource: MatTableDataSource<PixKey>;
	public displayedColumns: Array<string> = ['codigo', 'tipoChave', 'criadoEm', 'others'];
	public list: PixKey[] = [];

	constructor(
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog,
		private pixKeysClaimService: PixKeysClaimService,
	) {}

	ngOnInit(): void {
		this.getList();
	}

	getList() {
		this.pixKeysService.get().subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				this.list = Util.keysToCamel(result.Retorno) as PixKey[];
				this.dataSource = new MatTableDataSource(this.list);
				this.getListClaimsReceive();
			}
			this.getListClaimsRequest();
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	getListClaimsRequest() {
		const beginDate = moment(new Date()).subtract(14, 'days').format('YYYY-MM-DD');

		this.pixKeysClaimService.getRequest(beginDate, '').subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixKeyClaim[];
				items.forEach(o => {
					o.chave.modeloReividicacao = 'ENVIADA';
					o.chave.situacaoReividicacao = o.situacao as SituacaoReividicacao;
					o.chave.tipoReividicacao = o.tipo;
					o.chave.criadoEm = o.dataSolicitacao;
					o.chave.dataResolucaoReividicacao = o.dataResolucao;
					o.chave.sequencialReividicacao = o.sequencia;

					const duplicateIndex = this.list.findIndex(({ codigo }) => codigo === o.chave.codigo);
					if (duplicateIndex >= 0) {
						this.list.splice(duplicateIndex, 1);
					}

					this.list.push(o.chave);
				});
				this.dataSource = new MatTableDataSource(this.list);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	getListClaimsReceive() {
		const beginDate = moment(new Date()).subtract(14, 'days').format('YYYY-MM-DD');

		this.pixKeysClaimService.getReceive(beginDate, '').subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixKeyClaim[];
				items.forEach(o => {
					const itemInList = this.list.find(x => x.codigo === o.chave.codigo);
					itemInList.modeloReividicacao = 'RECEBIDA';
					itemInList.situacaoReividicacao = o.situacao as SituacaoReividicacao;
					itemInList.tipoReividicacao = o.tipo;
					itemInList.sequencialReividicacao = o.sequencia;
					itemInList.dataResolucaoReividicacao = o.dataResolucao;

				});
				this.dataSource = new MatTableDataSource(this.list);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	getTopText(item: PixKey): string {
		switch (item.tipoChave) {
			case PixKeyType.CPF:
				return 'CPF: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.CNPJ:
				return 'CNPJ: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.EMAIL:
				return 'E-mail: ' + item.codigo;
			case PixKeyType.PHONE:
				return 'Telefone celular: ' + Util.formatPhone(item.codigo);
			case PixKeyType.EVP:
				return 'Chave aleatória: ' + item.codigo ;
		}
	}

	openModalHelp() {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	showClaimTag(item: PixKey): boolean {
		return item.modeloReividicacao ? true : false;
	}

	showClaimText(item: PixKey): string {
		if (item.modeloReividicacao === 'ENVIADA') {
			if (item.situacaoReividicacao === SituacaoReividicacao.AGUARDANDO_RESOLUCAO || item.situacaoReividicacao === SituacaoReividicacao.ABERTA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					return 'Chave em reivindicação';
				}
				if (item.tipoReividicacao === 'PORTABILIDADE') {
					return 'Chave em portabilidade';
				}
			}

			if (item.situacaoReividicacao === SituacaoReividicacao.CONFIRMADA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					return 'Confirme a reivindicação';
				}
			}
		}

		if (item.modeloReividicacao === 'RECEBIDA') {
			if (item.situacaoReividicacao === SituacaoReividicacao.AGUARDANDO_RESOLUCAO || item.situacaoReividicacao === SituacaoReividicacao.ABERTA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					return 'Responder pedido de Reivindicação';
				}
				if (item.tipoReividicacao === 'PORTABILIDADE') {
					return 'Responder pedido de Portabilidade';
				}
			}
		}

		return '';
	}

	claimClick(item: PixKey) {
		if (item.modeloReividicacao === 'ENVIADA') {
			if (item.situacaoReividicacao === SituacaoReividicacao.AGUARDANDO_RESOLUCAO || item.situacaoReividicacao === SituacaoReividicacao.ABERTA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					this.showModalInfoClaimDate(item);
				}
				if (item.tipoReividicacao === 'PORTABILIDADE') {
					this.showModalPortabilityDate(item);
				}
			}

			if (item.situacaoReividicacao === SituacaoReividicacao.CONFIRMADA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					this.showModalClaimSuccess(item);
				}
				if (item.tipoReividicacao === 'PORTABILIDADE') {
					this.showModalPortabilitySuccess(item);
				}
			}
		}

		if (item.modeloReividicacao === 'RECEBIDA') {
			if (item.situacaoReividicacao === SituacaoReividicacao.AGUARDANDO_RESOLUCAO || item.situacaoReividicacao === SituacaoReividicacao.ABERTA) {
				if (item.tipoReividicacao === 'REIVINDICACAO') {
					this.showModalClaimReceive(item);
				}
				if (item.tipoReividicacao === 'PORTABILIDADE') {
					this.showModalPortabilityReceive(item);
				}
			}
		}
	}

	postConfimationOrCancelClaimPortability(item: PixKey, result: boolean) {
		item.paraConcluir = true;
		item.respostaConcluir = result;
		this.pixKeysClaimService.setPixKey(item);
		this.router.navigate(['pix/chaves/reivindicar']);
	}


	showModalClaimSuccess(item: PixKey) {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: 'Seu pedido de reivindicação de chave Pix deu certo. Confirme para concluir.',
				topText: this.getTopText(item),
				text: `Para sua segurança, confirme que esse número de celular é seu para poder utiliza-lo como uma chave Pix.`,
				btnName: 'Confirmar',
				btnBackName: 'Não quero mais essa chave'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined) {
				this.postConfimationOrCancelClaimPortability(item, result);
			}
		});
	}

	showModalPortabilitySuccess(item: PixKey) {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: 'Seu pedido de portabilidade de chave Pix deu certo. Confirme para concluir.',
				topText: this.getTopText(item),
				text: `Para sua segurança, confirme que esse número de celular é seu para poder utiliza-lo como uma chave Pix.`,
				btnName: 'Confirmar',
				btnBackName: 'Não quero mais essa chave'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined) {
				this.postConfimationOrCancelClaimPortability(item, result);
			}
		});
	}



	showModalInfoClaimDate(item: PixKey) {
		this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Chave em reivindicação',
				text: `Para começar a usar essa chave na Omni, você deve esperar até o dia ${moment(item.dataResolucaoReividicacao).format('DD/MM/YYYY')} para que a reivindicação seja confirmada.`,
				btnBackName: 'Fechar'
			}
		});
	}

	showModalPortabilityDate(item: PixKey) {
		this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Chave em processo de portabilidade',
				text: `Para concluir esse processo, acesse a conta onde essa chave esta registrada e confirme o pedido de portabilidade em até o dia ${moment(item.dataResolucaoReividicacao).format('DD/MM/YYYY')}`,
				btnBackName: 'Fechar'
			}
		});
	}

	showModalClaimReceive(item: PixKey) {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Pedido de reivindicação de posse da chave',
				topText: this.getTopText(item),
				text: `Isso significa que outra pessoa deseja registrar essa chave. Para manter a chave com você, confirme que quer mantê-la até dia ${moment(item.dataResolucaoReividicacao).format('DD/MM/YYYY')},
					ou libere a chave para a outra pessoa.`,
				btnName: 'Manter chave na Omni',
				btnBackName: 'Liberar chave'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined) {
				item.cancelarReividicacao = result;
				this.pixKeysClaimService.setPixKey(item);
				this.router.navigate(['pix/chaves/reivindicar']);
			}
		});
	}

	showModalPortabilityReceive(item: PixKey) {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Pedido de portabilidade',
				topText: this.getTopText(item),
				text: 'Isso significa que outro PSP registrou pedido em seu nome para que essa chave seja vinculada a outra conta. Para conclusão desse processo, é necessária a sua confirmação em até 7 (sete) dias.',
				btnName: 'Manter chave na Omni',
				btnBackName: 'Aceitar portabilidade'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined) {
				item.cancelarReividicacao = result;
				this.pixKeysClaimService.setPixKey(item);
				this.router.navigate(['pix/chaves/reivindicar']);
			}
		});
	}

	delete(item: PixKey) {
		const dialogRef = this.dialog.open(ModalConfirmComponent, {
			width: '350px',
			data: {
				title: 'Excluir chave para endereçamento',
				topText: this.getTopText(item),
				text: 'Se realmente prosseguir com a exclusão da chave acima, você não poderá mais receber pagamentos através dela. </br> Deseja excluir essa chave?'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				const pixKey = new PixKey();
				pixKey.codigo = item.codigo;
				pixKey.tipoChave = item.tipoChave as PixKeyType;
				this.pixKeysService.setPixKey(pixKey);
				this.router.navigate(['pix/chaves/excluir']);
			}
		});
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/list/keys/keys.component.ts